import React from 'react';
import './FirstLineBlackText.scss';

const FirstLineBlackText = ({ children }) => {
  return <div className="text b-700 lg-text maintenance-message">{children}</div>;
};

export default FirstLineBlackText;
